import React from 'react'
import { ReactComponent as Flows } from '../../assets/ic_flows.svg';

const FlowsIcon = () => <Flows />;

export default FlowsIcon;
